var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.01 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#4323ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.99,50c-.31-.14-.53-.34-.51-.71,.01-.32,.25-.58,.57-.62,.11-.01,.22-.01,.33-.01,2.67,0,5.34,0,8.01,0,1.45,0,2.67-.84,3.09-2.17,.12-.37,.17-.77,.17-1.15,.01-2.54,0-5.08,0-7.63,0-.1,0-.2,0-.31,.03-.35,.3-.6,.63-.61,.35-.01,.65,.23,.69,.58,.01,.1,0,.2,0,.31,0,2.55-.02,5.1,0,7.65,.03,2.54-1.85,4.4-3.95,4.64-.03,0-.06,.03-.09,.04h-8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,37.35c.11-.22,.23-.41,.49-.48,.38-.11,.78,.14,.84,.52,.02,.12,.01,.24,.02,.36,0,2.55,0,5.1,0,7.65,0,1.52,.93,2.77,2.35,3.14,.32,.08,.65,.12,.98,.12,2.58,0,5.17,0,7.75,0,.08,0,.15,0,.23,0,.38,.01,.65,.21,.71,.53,.06,.33-.09,.61-.44,.77-.02,.01-.04,.03-.06,.04H4.03s-.09-.04-.14-.05c-1.8-.31-3.02-1.32-3.65-3.03C.13,46.62,.08,46.29,0,45.97v-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,4.03c.05-.21,.09-.41,.14-.62C.65,1.41,2.43,.01,4.5,0c2.64,0,5.27,0,7.91,0,.4,0,.67,.21,.74,.56,.06,.3-.12,.63-.42,.73-.14,.05-.3,.05-.45,.05-2.56,0-5.12,0-7.68,0-1.5,0-2.73,.91-3.12,2.31-.09,.32-.13,.67-.13,1.01-.01,2.53,0,5.07,0,7.6,0,.1,0,.2,0,.31-.03,.29-.24,.53-.52,.59-.27,.06-.56-.06-.71-.3-.04-.06-.07-.13-.11-.2V4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M25.13,25.67c-7.82,0-15.64,0-23.47,0-.11,0-.22,0-.33,0-.34-.03-.59-.32-.6-.65,0-.35,.26-.64,.6-.67,.09,0,.19,0,.28,0,15.68,0,31.36,0,47.03,0,.56,0,.87,.24,.88,.66,0,.43-.32,.68-.89,.68-7.84,0-15.68,0-23.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.64,0c1.26,0,2.52,0,3.77,0,2.6,0,4.59,1.99,4.59,4.58,0,2.58,0,5.17,0,7.75,0,.56-.42,.9-.89,.73-.27-.09-.42-.28-.44-.56-.01-.11,0-.22,0-.33,0-2.52,0-5.03,0-7.55,0-1.54-.93-2.79-2.36-3.16-.31-.08-.64-.11-.96-.11-2.59,0-5.19,0-7.78,0-.47,0-.75-.22-.79-.59-.04-.44,.25-.75,.72-.75,.98,0,1.96,0,2.93,0,.4,0,.8,0,1.2,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInScan);
export default __webpack_public_path__ + "static/media/Check In Scan.de4169949a94288d9d2154852548a1c7.svg";
export { ForwardRef as ReactComponent };